import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GroupedComponents } from "../../components/GroupedComponents";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface PermanentElectricityDisconnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  applyButton?: LinkButtonProps;
  faqs?: FaqAccordionGroupProps;
  responsibilities?: ResponsibilitiesProps[];
}

export const PermanentElectricityDisconnectionPage: React.FC<PermanentElectricityDisconnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  applyButton,
  faqs,
  responsibilities,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      {lists && lists[1] && <List {...lists[1]} />}
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {applyButton && <LinkButton {...applyButton} />}
    </ServiceCataloguePageWrapper>
  );
};
